// IntegrationLogoutClear.page.tsx
// ★ 통합 명시 로그아웃 cross-origin clear 라우트 (/integration/logout-clear) — 상대 origin 이 띄운 iframe target.
//   실제 응답 로직은 index.html 의 inline script registerLogoutClearResponder (HTML parse 시점에 listener 등록 → race-safe).
//   본 페이지는 React Router 가 catch-all redirect 로 처리하지 않도록 막는 placeholder.
const IntegrationLogoutClear = () => null

export default IntegrationLogoutClear
